import React from 'react';
import { MessageCircle } from 'lucide-react';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  const handleWhatsApp = () => {
    const phoneNumber = '905518478521';
    const message = 'Merhaba, teknik servis hakkında bilgi almak istiyorum.';
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <button className="whatsapp-float" onClick={handleWhatsApp} aria-label="WhatsApp ile iletişime geç">
      <MessageCircle size={28} />
    </button>
  );
};

export default WhatsAppButton;